import { node, oneOfType, string } from "prop-types";
import styled from "styled-components/macro";
import { hideVisually } from "polished";

import defaultSource from "../../assets/img/placeholders/photos-placeholder.svg";

const PhotosPlaceholder = ({ alt, ...rest }) => {
  return (
    <Placeholder {...rest}>
      <AltText>{alt}</AltText>
    </Placeholder>
  );
};

const Placeholder = styled.div`
  background-image: url(${({ src }) => src});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const AltText = styled.span`
  ${hideVisually()};
`;

PhotosPlaceholder.propTypes = {
  alt: string,
  src: oneOfType([node, string]),
};

PhotosPlaceholder.defaultProps = {
  alt: "Photos Coming Soon",
  src: defaultSource,
};

export default PhotosPlaceholder;
